import { render, staticRenderFns } from "./reportePtiAceptadosV2.vue?vue&type=template&id=5eb9d8f0&scoped=true"
import script from "./reportePtiAceptadosV2.vue?vue&type=script&lang=js"
export * from "./reportePtiAceptadosV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb9d8f0",
  null
  
)

export default component.exports